class DemandPlannerActions {
  static DEMAND_PLANNER_REQUEST = "DEMAND_PLANNER_REQUEST";
  static DEMAND_PLANNER_SUCCESSFUL = "DEMAND_PLANNER_SUCCESSFUL";
  static DEMAND_PLANNER_FAILED = "DEMAND_PLANNER_FAILED";

  static demandPlannerRequest() {
    return {
      type: this.DEMAND_PLANNER_REQUEST
    };
  }
  static demandPlannerSuccessul(data) {
    return {
      type: this.DEMAND_PLANNER_SUCCESSFUL,
      data
    };
  }
  static demandPlannerFailed(error) {
    return {
      type: this.DEMAND_PLANNER_FAILED,
      error
    };
  }

  static DEMAND_PLANNER_SEC_MAT_REQUEST = "DEMAND_PLANNER_SEC_MAT_REQUEST";
  static DEMAND_PLANNER_SEC_MAT_SUCCESSFUL = "DEMAND_PLANNER_SEC_MAT_SUCCESSFUL";
  static DEMAND_PLANNER_SEC_MAT_FAILED = "DEMAND_PLANNER_SEC_MAT_FAILED";

  static demandPlannerSecMatRequest() {
    return {
      type: this.DEMAND_PLANNER_SEC_MAT_REQUEST
    };
  }
  static demandPlannerSecMatSuccessul(data) {
    return {
      type: this.DEMAND_PLANNER_SEC_MAT_SUCCESSFUL,
      data
    };
  }
  static demandPlannerSecMatFailed(error) {
    return {
      type: this.DEMAND_PLANNER_SEC_MAT_FAILED,
      error
    };
  }

  static DEMAND_PLANNER_SEC_MAT_SALE_MSKU_REQUEST = "DEMAND_PLANNER_SEC_MAT_SALE_MSKU_REQUEST";
  static DEMAND_PLANNER_SEC_MAT_SALE_MSKU_SUCCESSFUL = "DEMAND_PLANNER_SEC_MAT_SALE_MSKU_SUCCESSFUL";
  static DEMAND_PLANNER_SEC_MAT_SALE_MSKU_FAILED = "DEMAND_PLANNER_SEC_MAT_SALE_MSKU_FAILED";

  static demandPlannerSecMatSaleMskuRequest() {
    return {
      type: this.DEMAND_PLANNER_SEC_MAT_SALE_MSKU_REQUEST
    };
  }
  static demandPlannerSecMatSaleMskuSuccessul(data) {
    return {
      type: this.DEMAND_PLANNER_SEC_MAT_SALE_MSKU_SUCCESSFUL,
      data
    };
  }
  static demandPlannerSecMatSaleMskuFailed(error) {
    return {
      type: this.DEMAND_PLANNER_SEC_MAT_SALE_MSKU_FAILED,
      error
    };
  }

  static DEMAND_PLANNER_SEC_YOY_REQUEST = "DEMAND_PLANNER_SEC_YOY_REQUEST";
  static DEMAND_PLANNER_SEC_YOY_SUCCESSFUL = "DEMAND_PLANNER_SEC_YOY_SUCCESSFUL";
  static DEMAND_PLANNER_SEC_YOY_FAILED = "DEMAND_PLANNER_SEC_YOY_FAILED";

  static demandPlannerSecYoyRequest() {
    return {
      type: this.DEMAND_PLANNER_SEC_YOY_REQUEST
    };
  }
  static demandPlannerSecYoySuccessul(data) {
    return {
      type: this.DEMAND_PLANNER_SEC_YOY_SUCCESSFUL,
      data
    };
  }
  static demandPlannerSecYoyFailed(error) {
    return {
      type: this.DEMAND_PLANNER_SEC_YOY_FAILED,
      error
    };
  }

  static DEMAND_PLANNER_PRI_MAT_REQUEST = "DEMAND_PLANNER_PRI_MAT_REQUEST";
  static DEMAND_PLANNER_PRI_MAT_SUCCESSFUL = "DEMAND_PLANNER_PRI_MAT_SUCCESSFUL";
  static DEMAND_PLANNER_PRI_MAT_FAILED = "DEMAND_PLANNER_PRI_MAT_FAILED";

  static demandPlannerPriMatRequest() {
    return {
      type: this.DEMAND_PLANNER_PRI_MAT_REQUEST
    };
  }
  static demandPlannerPriMatSuccessul(data) {
    return {
      type: this.DEMAND_PLANNER_PRI_MAT_SUCCESSFUL,
      data
    };
  }
  static demandPlannerPriMatFailed(error) {
    return {
      type: this.DEMAND_PLANNER_PRI_MAT_FAILED,
      error
    };
  }

  static DEMAND_PLANNER_PRI_MAT_SALE_MSKU_REQUEST = "DEMAND_PLANNER_PRI_MAT_SALE_MSKU_REQUEST";
  static DEMAND_PLANNER_PRI_MAT_SALE_MSKU_SUCCESSFUL = "DEMAND_PLANNER_PRI_MAT_SALE_MSKU_SUCCESSFUL";
  static DEMAND_PLANNER_PRI_MAT_SALE_MSKU_FAILED = "DEMAND_PLANNER_PRI_MAT_SALE_MSKU_FAILED";

  static demandPlannerPriMatSaleMskuRequest() {
    return {
      type: this.DEMAND_PLANNER_PRI_MAT_SALE_MSKU_REQUEST
    };
  }
  static demandPlannerPriMatSaleMskuSuccessul(data) {
    return {
      type: this.DEMAND_PLANNER_PRI_MAT_SALE_MSKU_SUCCESSFUL,
      data
    };
  }
  static demandPlannerPriMatSaleMskuFailed(error) {
    return {
      type: this.DEMAND_PLANNER_PRI_MAT_SALE_MSKU_FAILED,
      error
    };
  }

  static DEMAND_PLANNER_PRI_YOY_REQUEST = "DEMAND_PLANNER_PRI_YOY_REQUEST";
  static DEMAND_PLANNER_PRI_YOY_SUCCESSFUL = "DEMAND_PLANNER_PRI_YOY_SUCCESSFUL";
  static DEMAND_PLANNER_PRI_YOY_FAILED = "DEMAND_PLANNER_PRI_YOY_FAILED";

  static demandPlannerPriYoyRequest() {
    return {
      type: this.DEMAND_PLANNER_PRI_YOY_REQUEST
    };
  }
  static demandPlannerPriYoySuccessul(data) {
    return {
      type: this.DEMAND_PLANNER_PRI_YOY_SUCCESSFUL,
      data
    };
  }
  static demandPlannerPriYoyFailed(error) {
    return {
      type: this.DEMAND_PLANNER_PRI_YOY_FAILED,
      error
    };
  }

  static DEMAND_PLANNER_DIFFERENCES_REQUEST = "DEMAND_PLANNER_DIFFERENCES_REQUEST";
  static DEMAND_PLANNER_DIFFERENCES_SUCCESSFUL = "DEMAND_PLANNER_DIFFERENCES_SUCCESSFUL";
  static DEMAND_PLANNER_DIFFERENCES_FAILED = "DEMAND_PLANNER_DIFFERENCES_FAILED";

  static demandPlannerDifferencesRequest() {
    return {
      type: this.DEMAND_PLANNER_DIFFERENCES_REQUEST
    };
  }
  static demandPlannerDifferencesSuccessul(data) {
    return {
      type: this.DEMAND_PLANNER_DIFFERENCES_SUCCESSFUL,
      data
    };
  }
  static demandPlannerDifferencesFailed(error) {
    return {
      type: this.DEMAND_PLANNER_DIFFERENCES_FAILED,
      error
    };
  }

  static ENUM_GREG_WEEKS_REQUEST = "ENUM_GREG_WEEKS_REQUEST";
  static ENUM_GREG_WEEKS_SUCCESSFUL = "ENUM_GREG_WEEKS_SUCCESSFUL";
  static ENUM_GREG_WEEKS_FAILED = "ENUM_GREG_WEEKS_FAILED";

  static enumGregWeeksRequest() {
    return {
      type: this.ENUM_GREG_WEEKS_REQUEST
    };
  }
  static enumGregWeeksSuccessul(data) {
    return {
      type: this.ENUM_GREG_WEEKS_SUCCESSFUL,
      data
    };
  }
  static enumGregWeeksFailed(error) {
    return {
      type: this.ENUM_GREG_WEEKS_FAILED,
      error
    };
  }
}

export default DemandPlannerActions;
